import {
  cyberBlogImg,
  reactBlogImg,
  amazonImg,
  aaqhseImg,
  modernPaymentImg,
  sharaImg,
  groupImg,
  resumeOneImg,
  resumeTwoImg,
  sliderImg,
  galleryImg,
} from "../assets/Assets";

export const projects = [
  {
    id: 3000,
    src: cyberBlogImg,
    title: "Cyber Security Blog",
    href: "https://noormohammad.live/",
  },
  {
    id: 3001,
    src: reactBlogImg,
    title: "Personal Blog",
    href: "https://my-blog-delta-eight.vercel.app/",
  },
  {
    id: 3002,
    src: amazonImg,
    title: "Amazon clone",
    href: "https://amazonproone.vercel.app/",
  },
  {
    id: 3003,
    src: aaqhseImg,
    title: "AA QHSE Demo",
    href: "https://aaoman.vercel.app/",
  },
  {
    id: 3004,
    src: modernPaymentImg,
    title: "Modern Payment Gateway",
    href: "https://modernpayment.vercel.app/",
  },
  {
    id: 3005,
    src: sharaImg,
    title: "Sahara Website Demo",
    href: "https://unknown2832021.github.io/Sahara_New_Beginning/",
  },
  {
    id: 3006,
    src: groupImg,
    title: "Group Work",
    href: "https://noormohammad-profile.netlify.app/",
  },
  {
    id: 3007,
    src: resumeOneImg,
    title: "Resume Test_Two",
    href: "https://noorjsdivs.github.io/portfolio-2/",
  },

  {
    id: 3008,
    src: resumeTwoImg,
    title: "Resume Test_One",
    href: "https://noorjsdivs.github.io/portfolio/",
  },
  {
    id: 3009,
    src: sliderImg,
    title: "Image Slider",
    href: " https://unknown2832021.github.io/slider/",
  },

  {
    id: 3010,
    src: galleryImg,
    title: "Image Gallery",
    href: "https://unknown2832021.github.io/image-viewer/",
  },
];
